import React from 'react';
import Modal from 'jd-library/Modal';

const BifurcateModel = props => {
	return (
        <Modal
        settings= {{modalId: 'bifurcateModal',
                variant: 'action',
                class: 'bifurcate-model'}}
        onHidden={() => {
        props.showBifurcateModel();
        }}
        >
            <Modal.Header className = {'new-design-modal-header'}>
            {'Select One Option'}
            </Modal.Header>
            <Modal.Body className = {'new-design-modal-body'}>
            <div className = {'new-design-modal'}>
                <div className = {'new-design-btn'}  onClick = {()=>props.choosedType('product')}>
                <div className="icon-holder bifurcate">
                    <i class="icon-Add_product" />
                </div>
                <div className = 'create-text'>{'Add New Product'}</div>
                </div>
                <div className = {'new-design-btn '} onClick = {()=>props.choosedType('service')}>
                <div className="icon-holder bifurcate">
                    <i class="icon-Add_service" />
                </div>
                <div className = 'create-text'>{'Add New Service'}</div>
                </div>
            </div>
            </Modal.Body>
    </Modal>
	);
};

export default BifurcateModel;
